import { motion, useReducedMotion } from 'motion/react';
import { useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';
import { pageTransition, pageTransitionReduced } from './motion-tokens';

type Props = {
  children: ReactNode;
};

/**
 * Fade + léger y à l’entrée de route.
 * Pas d’exit AnimatePresence : Outlet RR reflète toujours la location courante,
 * ce qui casserait le contenu sortant.
 */
export function PageTransition({ children }: Props) {
  const location = useLocation();
  const reduceMotion = useReducedMotion();
  const variants = reduceMotion ? pageTransitionReduced : pageTransition;

  return (
    <motion.div
      key={location.pathname}
      className="page-transition"
      initial={variants.initial}
      animate={variants.animate}
      transition={variants.transition}
    >
      {children}
    </motion.div>
  );
}
